export type StudioUser = {
  id: number;
  ss_user_id: number;
  username: string;
  name: string;
  email: string;
  avatar: string;
  is_artist: boolean;
};

const TOKEN_KEY = "ss_studio_token";

export function apiUrl(path: string) {
  return path.startsWith("http") ? path : `/api/${path.replace(/^\/+/, "")}`;
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function api<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (init.body && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const token = getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  const res = await fetch(apiUrl(path), { ...init, headers, credentials: "include" });
  const data = (await res.json().catch(() => ({}))) as T & { error?: string; status?: number };
  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}
